import { gql } from '@apollo/client'

export const GET_RATING_STATS = gql`
    query GetRatingStats ($id: ID!) {
        ratingStats (id: $id) {
            stars
        }
    }
`

export const GET_RATING_STATS_BY_SLUG = gql`
    query GetRatingStatsBySlug ($slug: String!) {
        ratingStatsBySlug (slug: $slug) {
            stars
        }
    }
`
